










































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { snackModule, authModule } from '@/store';
import { Vehicle } from '@/api';
import AbstractTable from '@/components/admin/AbstractTable.vue';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';
import VehicleModalEdit from '@/components/admin/VehicleModalEdit.vue';

@Component({
  components: {
    AbstractTable,
    ConfirmDialog,
    VehicleModalEdit,
  },
})
export default class extends Vue {
  selectedVehicles: Vehicle[] = [];
  vehicleConfirmDialog: boolean = false;
  vehicleAddEdit: boolean = false;
  vehicleToEdit: Vehicle | null = null;

  get windowSize() {
    return window.outerWidth;
  }

  get vehicleHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Rego',
        value: 'rego',
        width: 100,
      },
      {
        text: 'Make',
        value: 'make',
      },
      {
        text: 'Model',
        value: 'model',
      },
      {
        text: 'Type',
        value: 'vehicleType.name',
      },
      {
        text: 'Colour',
        value: 'colour',
      },
    ];
  }

  get vehicleScope() {
    return () =>
      Vehicle.includes(['vehicleType']).where({
        owner: this.customerId,
        deleted: false,
      });
  }

  get selectedVehicle() {
    return this.selectedVehicles[0] || null;
  }

  get customerId() {
    if (!authModule.user || !authModule.user.customer) {
      return;
    }
    return authModule.user.customer.id;
  }

  vehicleClicked(item: Vehicle) {
    if (!item) {
      return;
    }

    this.vehicleToEdit = item;
    this.vehicleAddEdit = true;
  }

  addVehicle(edit: boolean = false) {
    if (edit) {
      this.vehicleToEdit = this.selectedVehicle;
    } else {
      this.vehicleToEdit = null;
    }

    this.vehicleAddEdit = true;
  }

  confirmDeleteVehicle() {
    this.vehicleConfirmDialog = true;
  }

  vehicleSaved() {
    this.vehicleAddEdit = false;
    snackModule.showSnackbar('Vehicle Saved');
    this.updateVehicles();
  }

  updateVehicles() {
    (this.$refs.vehicleTable as AbstractTable).update();
  }

  async deleteSelectedVehicle() {
    if (!this.selectedVehicle) {
      return;
    }

    try {
      this.selectedVehicle.deleted = true;
      await this.selectedVehicle.save();
    } catch (err) {
      // Error
    } finally {
      this.vehicleConfirmDialog = false;
      this.selectedVehicles = [];
      this.updateVehicles();
    }
  }

  mounted() {
    if (!authModule.isLoggedIn) {
      this.$router.push({
        name: 'login',
        query: { next: window.location.pathname },
      });
    }
  }
}
